import React from 'react';
import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import WhatshotIcon from '@mui/icons-material/Whatshot';

const CurrentChallengeCard = (challengeData = {}) => {
  const [data, setData] = useState(challengeData);

  useEffect(() => {
    // console.log('challengeData', challengeData);
    setData(challengeData.challengeData);
  }, [challengeData]);

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      setData({
        challenge: 'Avoid Fast Food For 1 Week',
        weekStreak: 3,
        thisWeekCheckIn: {
          monday: 'checked',
          tuesday: 'not checked',
          wednesday: 'checked',
          thursday: 'checked',
          friday: 'checked',
          saturday: 'tbd',
          sunday: 'tbd',
        },
      });
    }
  }, [data]);

  const dayStatus = data.thisWeekCheckIn
    ? {
        Mo: data.thisWeekCheckIn.monday,
        Tu: data.thisWeekCheckIn.tuesday,
        We: data.thisWeekCheckIn.wednesday,
        Th: data.thisWeekCheckIn.thursday,
        Fr: data.thisWeekCheckIn.friday,
        Sa: data.thisWeekCheckIn.saturday,
        Su: data.thisWeekCheckIn.sunday,
      }
    : {};

  return (
    <Box
      id="container"
      sx={{
        width: '678.08px',
        height: '297.28px',
        gap: '0px',
        borderRadius: '12px 0px 0px 0px',
        border: '1px solid var(--color4, #EBE8F3)',
      }}
    >
      <Box
        id="current-challenge-main"
        sx={{
          // border: '1px solid green',
          width: '678.08px',
          height: '186.28px',
          padding: '24px 32px 24px 32px',
          gap: '32px',
          background: '#F8F8F8',
        }}
      >
        <Box
          id="current-challenge-content"
          sx={{
            // border: '1px solid red',
            width: '614.08px',
            height: '138.28px',
            gap: '32px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            id="current-challenge-left-box"
            sx={{
              // border: '1px solid grey',
              width: '320px',
              height: '138.28px',
              gap: '24px',
            }}
          >
            <Box
              id="current-challenge-label"
              sx={{
                // border: '1px solid violet',
                width: '320px',
                height: '78px',
                gap: '20px',
              }}
            >
              <Typography
                sx={{
                  width: '320px',
                  height: '20px',
                  gap: '0px',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '19.5px',
                  textAlign: 'left',
                  textUnderlinePosition: 'from-font',
                  textDecorationSkipInk: 'none',
                }}
              >
                Current Challenge
              </Typography>
              <Box
                id="challenge-title"
                sx={{
                  width: '320px',
                  height: '46px',
                  gap: '12px',
                }}
              >
                <Typography
                  sx={{
                    width: '320px',
                    height: '46px',
                    gap: '0px',
                    fontFamily: 'Montserrat',
                    fontSize: '24px',
                    fontWeight: 700,
                    lineHeight: '29.26px',
                    textAlign: 'left',
                    textUnderlinePosition: 'from-font',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  {data.challenge}
                </Typography>
              </Box>
            </Box>
            <Box
              id="check-in-label"
              sx={{
                // border: '1px solid violet',
                width: '267.84px',
                height: 'var(--3)',
                padding: 'var(--0) var(--3) var(--0) var(--3)',
                gap: 'var(--3)',
                borderRadius: 'var(--3)',
                transform: 'rotate(0.06deg)',
                background:
                  'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(76, 175, 80, 0.32), rgba(76, 175, 80, 0.32))',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  backgroundColor: 'rgba(76, 175, 80, 0.5)',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontWeight: 700,
                  lineHeight: '19.5px',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px 62px 8px 62px',
                  borderRadius: '5px',
                }}
              >
                ✓ Checked In Today
              </Typography>
            </Box>
            {/* Content for the new left half box */}
          </Box>
          <Box
            id="current-challenge-divider"
            sx={{
              width: '2px',
              height: '110px',
              border: '2px solid #EFEFEF',
              alignSelf: 'center',
              margin: '0 auto',
            }}
          />
          <Box
            id="current-challenge-right-box"
            sx={{
              // border: '1px solid black',
              width: '230.08px',
              height: '74px',
              gap: '19px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              id="fire-icon-box"
              sx={{
                width: '74px',
                height: '74px',
                padding: '0px',
                gap: '7.12px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#E1DDED',
              }}
            >
              <WhatshotIcon size={40} />
            </Box>
            <Box
              id="streak-info"
              sx={{
                width: '102px',
                height: '62px',
                gap: '8px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Typography
                sx={{
                  width: '29px',
                  height: '34px',
                  gap: '0px',
                  fontFamily: 'Montserrat',
                  fontSize: '48px',
                  fontWeight: 700,
                  lineHeight: '58.51px',
                  textAlign: 'left',
                  textUnderlinePosition: 'from-font',
                  textDecorationSkipInk: 'none',
                }}
              >
                {data.weekStreak}
              </Typography>
              <Typography
                sx={{
                  marginTop: '5px',
                  width: '102px',
                  height: '20px',
                  gap: '0px',
                  fontFamily: 'Montserrat',
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: '19.5px',
                  textAlign: 'left',
                  textUnderlinePosition: 'from-font',
                  textDecorationSkipInk: 'none',
                }}
              >
                Week Streak
              </Typography>
            </Box>
          </Box>
          {/* Content for the right half or other elements */}
        </Box>
      </Box>
      <Box
        id="weekly-calendar"
        sx={{
          border: '1px solid blue',
          width: '678.08px',
          height: '111px',
          padding: '24px 40px 16px 40px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {Object.entries(dayStatus).map(([day, status], index) => (
          <Box
            key={index}
            sx={{
              width: '28px',
              height: '49px',
              // backgroundColor: '#ccc',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                width: '28px',
                height: '28px',
                padding: '5px 4px 3px 4px',
                gap: '0px',
                borderRadius: '50%',
                position: 'absolute',
                top: 0,
                left: 0,
                backgroundColor: status === 'checked' ? '#4caf50' : status === 'not checked' ? '#b8b8b8' : '#eee',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#fff',
              }}
            >
              {status === 'checked' && '✓'}
              {status === 'not checked' && '−'}
            </Box>
            <Typography
              sx={{
                width: '28px',
                height: '13px',
                gap: '0px',
                fontFamily: 'Montserrat',
                fontSize: '18px',
                fontWeight: 700,
                lineHeight: '21.94px',
                textAlign: 'center',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                marginTop: '30px',
              }}
            >
              {day}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CurrentChallengeCard;
